(function() {
  function initInPageNav() {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('[data-in-page-nav] .in-page-nav__link');
      if (!link) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      var id = link.getAttribute('data-anchor-id');
      if (!id) return;
      
      var target = document.getElementById(id);
      if (!target) {
        console.warn('In-Page Nav: Ziel #' + id + ' nicht gefunden');
        return;
      }
      
      // Wichtig: Shopify-Section-Wrapper hat die korrekte Position,
      // das innere Div kann bei 0 rendern
      var scrollTarget = target.closest('.shopify-section') || target;
      
      var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 174;
      var headerOffset = headerHeight + 20;
      var targetY = scrollTarget.getBoundingClientRect().top + window.scrollY - headerOffset;
      
      console.log('In-Page Nav: Scrolle zu y=' + targetY);
      
      window.scrollTo({ top: targetY, behavior: 'smooth' });
      if (history.pushState) {
        history.pushState(null, '', '#' + id);
      }
    }, true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInPageNav);
  } else {
    initInPageNav();
  }
})();